import { useUpdateParagraph } from "@EditArticleContainer/shared/hooks/useUpdateParagraph";
import { ParagraphContent } from "@EditArticleContainer/shared/types/paragraphContents/paragraphContents.types";

import DrugProfileTable from "./components/DrugProfileTable/DrugProfileTable";
import * as S from "./DrugProfileTableGroup.style";

interface Props {
  drugProfile: ParagraphContent["TC003"];
}

const DrugProfileTableGroup = ({ drugProfile }: Props) => {
  const [updateDrugProfileTable, loadingDrugProfileTableIndex] =
    useUpdateParagraph({
      paragraphCode: "TC003",
      sectionCode: "TY001",
    });

  return (
    <S.DrugProfileTableWrapper>
      <S.ParagraphDrugProfileUpdateButton
        onClick={() => updateDrugProfileTable(0)}
        disabled={loadingDrugProfileTableIndex === 0}
      />
      <>
        {drugProfile?.text?.["Drug profile"]?.map?.((tableData, index) => {
          return (
            <DrugProfileTable
              key={`clinical-trials-drug-profile-${String(index)}`}
              tableData={tableData}
              index={index}
            />
          );
        })}
      </>
    </S.DrugProfileTableWrapper>
  );
};

export default DrugProfileTableGroup;
